import { createMuiTheme } from "@material-ui/core/styles";

export function createTheme() {
  const validPrimaryColor = "#3685B5";
  const validSecondaryColor = "#ffffff";

  return createMuiTheme({
    palette: {
      type: "light",
      primary: {
        main: validPrimaryColor
      },
      secondary: {
        main: "#A4243B"
      },
      alternate: {
        main: "#32936F"
      },
      background: {
        default: validSecondaryColor
      }
    }
  });
}
